var indentStyle = {"indentZero":"_-7CKp","indentOne":"kJUgJ","indentTwo":"_2g9we","indentThree":"ydmUp","indentFour":"pBTPk","indentFive":"OxmJi","indentSix":"Tx4iZ"};

export { indentStyle as i };
//# sourceMappingURL=indentation-c186d1e3.js.map
